import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getCanRedeemInsuranceLoyaltyBenefit from './getCanRedeemInsuranceLoyaltyBenefit'

const getEligibleInsuranceLoyaltyTier = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => state.loyalty.account.data?.tier,
  (state: App.State) => getCanRedeemInsuranceLoyaltyBenefit(state),
  (isLoyaltyEnabled, loyaltyTier, canRedeemInsuranceLoyaltyBenefit): App.LoyaltyTier | undefined => {
    if (!isLoyaltyEnabled || !loyaltyTier || !canRedeemInsuranceLoyaltyBenefit) return undefined
    return loyaltyTier
  },
)

export default getEligibleInsuranceLoyaltyTier
